export default __webpack_public_path__ + "static/media/pax00.2dfa763e.jpg";